import React, { useState } from 'react';
import Navbar from '../../components/Navbar';
import API from '../../utils/api';
import toast from 'react-hot-toast';
import { useAuth } from '../../context/AuthContext';

const SCIENCE_SUBJECTS = ['Mathematics','Physics','Chemistry','Biology','Computer Science','Statistics','Botany','Zoology'];
const ARTS_SUBJECTS = ['History','Geography','Political Science','Economics','Sociology','Psychology','English','Hindi','Bengali','Sanskrit','Philosophy'];

export default function TeacherProfile() {
  const { user, refreshUser } = useAuth();
  const [form, setForm] = useState({ full_name: user?.full_name||'', subjects: user?.subjects ? JSON.parse(user.subjects) : [], custom_subject:'' });
  const [pwForm, setPwForm] = useState({ old_password:'', new_password:'', confirm_password:'' });
  const [saving, setSaving] = useState(false);
  const [changingPw, setChangingPw] = useState(false);

  const subjects = user?.role === 'science_teacher' ? SCIENCE_SUBJECTS : ARTS_SUBJECTS;

  const toggleSubject = s => setForm(f => ({ ...f, subjects: f.subjects.includes(s) ? f.subjects.filter(x=>x!==s) : [...f.subjects, s] }));

  const addCustom = () => {
    if (!form.custom_subject.trim()) return;
    const customs = form.custom_subject.split(',').map(s=>s.trim()).filter(Boolean);
    setForm(f => ({ ...f, subjects: [...new Set([...f.subjects, ...customs])], custom_subject:'' }));
  };

  const saveProfile = async e => {
    e.preventDefault(); setSaving(true);
    try {
      await API.put('/auth/profile', { full_name: form.full_name, subjects: form.subjects });
      await refreshUser();
      toast.success('✅ Profile updated!');
    } catch (err) { toast.error(err.response?.data?.error||'Error'); }
    finally { setSaving(false); }
  };

  const changePassword = async e => {
    e.preventDefault();
    if (pwForm.new_password !== pwForm.confirm_password) return toast.error('Passwords do not match');
    setChangingPw(true);
    try {
      await API.put('/auth/change-password', { old_password: pwForm.old_password, new_password: pwForm.new_password });
      toast.success('✅ Password changed!');
      setPwForm({ old_password:'', new_password:'', confirm_password:'' });
    } catch (err) { toast.error(err.response?.data?.error||'Error'); }
    finally { setChangingPw(false); }
  };

  return (
    <div>
      <Navbar />
      <div style={{ maxWidth:700, margin:'0 auto', padding:'32px 20px' }}>
        <div className="page-header"><h1>👤 My Profile</h1><p>Update your information</p></div>

        <form onSubmit={saveProfile}>
          <div className="card" style={{ marginBottom:24 }}>
            <h3 style={{ fontWeight:700, marginBottom:20 }}>📋 Profile Info</h3>
            <div className="form-group">
              <label>Full Name</label>
              <input value={form.full_name} onChange={e => setForm(f=>({...f,full_name:e.target.value}))} />
            </div>
            <div className="form-group">
              <label>Phone</label>
              <input value={user?.phone||''} disabled style={{ opacity:0.6 }} />
              <p style={{ fontSize:11, color:'var(--text3)', marginTop:4 }}>Contact admin to change phone number</p>
            </div>
            <div className="form-group">
              <label>Subjects (select multiple)</label>
              <div style={{ display:'flex', flexWrap:'wrap', gap:6, marginBottom:10 }}>
                {subjects.map(s => (
                  <button type="button" key={s} onClick={() => toggleSubject(s)} style={{ padding:'5px 12px', borderRadius:20, border:'1px solid', cursor:'pointer', fontSize:12, fontWeight:600, background:form.subjects.includes(s)?'var(--primary)':'var(--card2)', color:form.subjects.includes(s)?'white':'var(--text2)', borderColor:form.subjects.includes(s)?'var(--primary)':'var(--border)' }}>{s}</button>
                ))}
              </div>
              <div style={{ display:'flex', gap:8 }}>
                <input value={form.custom_subject} onChange={e => setForm(f=>({...f,custom_subject:e.target.value}))} placeholder="Custom subject (comma separated)" />
                <button type="button" onClick={addCustom} className="btn btn-secondary btn-sm">+ Add</button>
              </div>
              {form.subjects.length > 0 && (
                <div style={{ marginTop:8, display:'flex', flexWrap:'wrap', gap:4 }}>
                  {form.subjects.map(s => (
                    <span key={s} style={{ padding:'3px 10px', borderRadius:20, background:'rgba(99,102,241,0.2)', color:'var(--primary-light)', fontSize:11, display:'flex', alignItems:'center', gap:4 }}>
                      {s} <button type="button" onClick={() => setForm(f=>({...f,subjects:f.subjects.filter(x=>x!==s)}))} style={{ background:'none', border:'none', color:'inherit', cursor:'pointer', fontSize:14 }}>×</button>
                    </span>
                  ))}
                </div>
              )}
            </div>
            <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? '⏳ Saving...':'💾 Save Profile'}</button>
          </div>
        </form>

        <form onSubmit={changePassword}>
          <div className="card">
            <h3 style={{ fontWeight:700, marginBottom:20 }}>🔑 Change Password</h3>
            <div className="form-group"><label>Current Password</label><input type="password" value={pwForm.old_password} onChange={e => setPwForm(f=>({...f,old_password:e.target.value}))} required /></div>
            <div className="form-group"><label>New Password</label><input type="password" value={pwForm.new_password} onChange={e => setPwForm(f=>({...f,new_password:e.target.value}))} required /></div>
            <div className="form-group"><label>Confirm New Password</label><input type="password" value={pwForm.confirm_password} onChange={e => setPwForm(f=>({...f,confirm_password:e.target.value}))} required /></div>
            <button type="submit" className="btn btn-warning" disabled={changingPw}>{changingPw ? '⏳ Changing...':'🔑 Change Password'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
